import React from 'react';
import PropTypes from 'prop-types';

import ShopControl from 'lib/apps/header/containers/ShopControl';
import MyAccount from '../containers/MyAccount';

export default function HeaderButtons({ isLoggedIn, shopControlsVisibility }) {
  return (
    <div className="hd-authButtons">
      <div className="btn-wrapper">
        <MyAccount isLoggedIn={isLoggedIn} />
      </div>
      <div className="btn-wrapper">
        <ShopControl shopControlsVisibility={shopControlsVisibility} />
      </div>
    </div>
  );
}

HeaderButtons.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  shopControlsVisibility: PropTypes.string.isRequired,
};
